import { h } from 'preact';
import { useCallback, useMemo, useRef } from 'preact/hooks';
import { connect, withBreakPoints } from '../../../hoc';
import { embed } from '../../../../../configuration';
import {
  EMBED_POPUP_TITLE,
  EMBED_POPUP_TEXTAREA,
  EMBED_POPUP_TEXTAREA_SELECTED,
  EMBED_POPUP_COPIED,
  EMBED_POPUP_WRAPPER
} from './styles';
import { useStyles } from '../../../hooks';
import { TEXT_LEVEL_2_FONT_SIZE } from '../../../styles';
import { ENTER_BUTTTONS_LIST } from '../../../../../core/shortcut/types';

function EmbedScreen({
  embedKey,
  embedError,
  message,
  copied,
  copyEmbedIframe
}) {
  const wrapperRef = useRef(null);
  const textArea = useRef(null);
  const setStyles = useStyles();

  const embedIframe = useMemo(() => (embedKey
    ? `<iframe width="560" height="315" src="${embed.iframe}${embedKey}" title="Lecteur vidéo embed France télévisions" frameborder="0" scrolling="no" allowfullscreen></iframe>`
    : ''), [embedKey]);

  const copyEmbedLink = useCallback((e) => {
    e.stopPropagation();

    if (!embedKey) {
      e.preventDefault();
      return;
    }

    textArea.current.select();
    document.execCommand('copy');
    copyEmbedIframe();

    const modal = wrapperRef.current.parentElement;
    const closeEmbed = modal.querySelector('[name="btn-close-embed"]');
    closeEmbed?.focus();
  }, [copyEmbedIframe, embedKey]);

  const textToShow = useMemo(() => {
    if (embedError) {
      return message;
    }

    if (embedKey) {
      return embedIframe;
    }

    return 'Chargement...';
  }, [embedError, embedIframe, embedKey, message]);

  const textSpanStyle = useMemo(() => (embedKey
    ? EMBED_POPUP_TEXTAREA_SELECTED
    : { ...EMBED_POPUP_TEXTAREA_SELECTED, wordBreak: 'break-word' }
  ), [embedKey]);

  return (
    <div
      ref={wrapperRef}
      style={setStyles(EMBED_POPUP_WRAPPER)}
    >
      <div style={{ ...setStyles(EMBED_POPUP_TITLE) }}>Code à intégrer</div>
      <div
        className="ftv-magneto--btn ftv-magneto--focusable-item"
        style={{
          ...setStyles(TEXT_LEVEL_2_FONT_SIZE),
          ...EMBED_POPUP_TEXTAREA
        }}
        onClick={copyEmbedLink}
        tabIndex={0}
        onKeyDown={(e) => [13, 32 /* Space or Enter */, ...ENTER_BUTTTONS_LIST].includes(e.keyCode) && copyEmbedLink(e)}
        role="button"
      >
        <span tabIndex={-1} style={textSpanStyle}>{textToShow}</span>
        <textarea
          className="embed-container"
          style={{ height: 0, width: 0, opacity: 0 }}
          value={textToShow}
          ref={textArea}
          tabIndex={-1}
        />
      </div>
      <div style={setStyles(EMBED_POPUP_COPIED)}>
        <span hidden={!copied}>copié !</span>
      </div>
    </div>
  );
}

const selector = ({
  ui: { embedKey },
  media: { embedError, message }
}) => ({ embedKey, embedError, message });
export default withBreakPoints(connect(selector)(EmbedScreen));
